module.exports =  {
  TITLE: {
    default: 'Cari Hotel|Ribu-an hotel di Asia online untuk pemesanan',
    detail: '|Pemesanan Hotel',
  },
  hotel: {
    // 酒店搜索改版新增翻译--英文
    ROOMS: 'Kamar',
    GUESTS: 'Tamu',
    CHECK_IN_NUM: 'Tamu',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Dewasa',
    SUFFIX_ADULTS: 'Dewasa',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Anak',
    SUFFIX_CHILDREN: 'Anak-anak',
    CHILD_AGE: 'Usia Anak',
    NO_MATCH_TIPS: 'Tipe kamar di bawah ini tidak sesuai dengan jumlah kamar dan tamu yang Anda pilih.',

    Book_Hotel: 'Pesan Hotel',
    Select_your_destination: 'Pilih tujuan Anda',
    Please_enter_your_destination: 'Silakan masukkan tujuan/hotel Anda',
    Booked_up: 'Penuh',
    Hotel_description: 'Deskripsi Hotel',
    Check_in_date: 'Tanggal Check-in',
    Check_out_date: 'Tanggal Check-out',
    Sold_out: 'Habis terjual',
    Non_refundable: 'Tidak dapat dikembalikan',
    reserve: 'Pesan',
    Pay_Online: 'Bayar Online',
    Only_rooms_left_before: 'Hanya ',
    Only_rooms_left_after: ' kamar tersisa',
    Cancellation_Policy: 'Kebijakan Pembatalan',
    See_all_prices_before: 'Lihat semua ',
    See_all_prices_after: 'harga',
    Estimated_time_of_arrival: 'Perkiraan waktu kedatangan',
    make_your_schedule_well_planned: 'Waktu adalah untuk zona waktu lokal, harap rencanakan jadwal Anda dengan baik dan datang tepat waktu.',
    Hotel_Not_Found: 'Hotel Tidak Ditemukan',
    Please_change_your_search: 'Silakan ubah pencarian Anda',
    Submit_an_application: 'Kirimkan aplikasi',
    Hotel_Confirmation: 'Konfirmasi Hotel',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Malam Menginap',
    Hotel_Booking_Number: 'Nomor Pemesanan Hotel',
    Online_Payment: 'Pembayaran Online',
    The_guest_Room_before: 'Tamu[Kamar',
    The_guest_Room_after: ']',
    Contact_number: 'Nomor kontak',
    Bring_all_valid_IDs: 'Harap bawa semua ID valid dari semua tamu saat check-in.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotel Ditemukan',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotel Disajikan (',
    Hotels_Presented_after: ' secara total)',
    Please_change_the_dates: 'Kamar tidak tersedia pada tanggal Anda, silakan ubah tanggal.',
    Login: 'Masuk di APL untuk memesan hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Malam secara total',
    Location: 'Lokasi',
    Pictures: 'Gambar',
    Description: 'Deskripsi',
    Policy: 'Kebijakan',
    Check_in_and_check_out_time: 'Waktu Check-in dan Check-out',
    Check_in_and_Check_out_before: 'Check-in: setelah ',
    Check_in_and_Check_out_center: 'Check-out: sebelum ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Check-in',
    Check_out_time: 'Check-out',
    Facility_Service: 'Fasilitas & Layanan',
    Payment_methods: 'Metode pembayaran yang diterima oleh hotel',
    Hotel_Address: 'Alamat Hotel',
    Pay_online: 'Bayar online',
    Pay_offline: 'Bayar secara offline',
    Night_stay_before: '',
    Night_stay_after: '-Malam Menginap,',
    Rooms_total_before: 'Kamar',
    Rooms_total_after: 'secara total',
    Guest_name_must_be_provided: 'Nama lengkap tamu harus disediakan.',
    Please_fill_in_your_contact_number: 'Harap isi nomor kontak Anda',
    Select_estimated_time_of_arrival: 'Pilih perkiraan waktu kedatangan',
    Number_of_Rooms: 'Jumlah Kamar',
    Maximum_guests_per_room_before: 'Maksimum ',
    Maximum_guests_per_room_after: ' tamu per kamar',
    Many_Rooms: ' Kamar',
    Service_Fee_Included: '(Pajak & Biaya Layanan Termasuk)',
    Last_Name: 'Nama Belakang',
    First_Name: 'Nama Depan ',
    Room: 'Kamar',
    Additional_Tax: 'Pajak Tambahan',
    Please_inform_the_hotel: 'Jika Anda akan tiba melewati waktu kedatangan perkiraan, harap beri tahu hotel sebelumnya.',
    Please_inform_the_hotel_first: 'Kedatangan di hotel melewati waktu kedatangan perkiraan tanpa menghubungi hotel sebelumnya akan mempengaruhi ketersediaan kamar dan makan malam. Harap beri tahu hotel terlebih dahulu untuk mengonfirmasi ketersediaan dalam keadaan seperti itu.',
    Booking_Cancellation: 'Pembatalan Pemesanan',
    Reason_of_Cancellation: 'Alasan Pembatalan',
    Incorrect_Information_Filled: 'Informasi Salah Diisi',
    Itinerary_Changed: 'Rencana Perjalanan Diubah',
    Lower_price_on_other_APP: 'Harga lebih rendah di aplikasi lain',
    Low_quality_hotel: 'Hotel berkualitas rendah',
    Book_at_a_lower_price: 'Pesan dengan harga lebih rendah di meja depan',
    Other: 'Lainnya',
    Please_write_your_reason: 'Silakan tuliskan alasan Anda',
    After_cancellation_done: 'Setelah pembatalan selesai, pembayaran akan dikembalikan ke pembayar asli dalam waktu 3 hari kerja.',
    How_to_fill_in_the_guest_name: 'Cara mengisi nama tamu',
    It_should_be_exactly_the_same: 'Harap berikan nama tamu dalam huruf Inggris untuk pemesanan hotel. Harus persis sama dengan sertifikat yang disajikan saat check-in.',
    How_to_fill_in_a_Chinese_name: 'Cara mengisi nama Tionghoa:',
    How_to_fill_in_a_English_name: 'Cara mengisi nama Inggris',
    For_example: 'Contoh: Jika nama Tionghoa Anda adalah "韩梅梅", nama belakangnya adalah "Han", nama depannya adalah "Meimei".',
    No_specical_characters: 'Jangan isi angka atau karakter khusus apa pun. ',
    Name_rule_first: 'Nama belakang terlebih dahulu, diikuti oleh nama depan, dan jika ada nama tengah, diikuti oleh spasi di belakang dua nama tersebut. ',
    Name_rule_second: 'Contoh: Green / Jim Stephanie',
    Details: 'Detail',
    Pay_now: 'Bayar sekarang',
    Hotel: 'Hotel',
    Check_in: 'Check  in',
    Car: 'Mobil',
    All_bookings: 'Semua pemesanan',
    All: 'Semua',
    PROMPT: 'Perhatian',


    Search: 'Cari',
    COST_DESCRIPTION: 'Rincian Harga',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Bayar',
    KONW: 'Paham',
    BOOKING_INFORMATION: 'Informasi Penting',
    Book_Now: 'Bayar Sekarang',
    MAP: 'Peta',
    CONTACT_INFORMATION: 'Informasi Kontak',
    LOADING: 'Memuat...',
    SORT_FILTER: 'Urut/Filtrasi',
    SCREENING: 'Filter',
    SEQUENCE: 'Urutan',
    PHONE_ASK: 'Hubungi kami',
    ABOVE: '',
    SUBMINT_ORDER: 'Kirim',
    OK: 'OK',
    Order_detail: 'Detail Pemesanan',
    BOOKING_INFO: 'Info Pemesanan',
    PAYMENT_AMOUNT: 'Jumlah Pembayaran',
    Order_time: 'Waktu Pemesanan',
    ORDER_NUMBERS: 'Nomor Pemesanan',
    PAY_TYPE: 'Metode Pembayaran',
    BALANCE: 'Saldo',
    CURRENT_BALANCE_BEGIN: 'Saldo',
    OVERPLUS_BALANCE_BEGIN: 'Sisa',
    OTHER_PAYMENT: 'Metode pembayaran lainnya',
    Unionpay: 'UnionPay',
    Wechatpay: 'Pembayaran WeChat',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Klik "Bayar Sekarang" berarti Anda setuju dengan ',
    AGREE_SERVICE_AGREEMENT_AFTER: ' Baigolf',
    SERVICE_AGREEMENT: '《Perjanjian Layanan》',
    PAYMENT_ORDER: 'Pembayaran Pemesanan',
    Total_pay: 'Jumlah yang Harus Dibayar',
    PAY_SUCCESS: 'Pembayaran Diterima',
    CHECK_THE_ORDER: 'Periksa Pemesanan',
    BACK_TO_INDEX: 'Kembali ke Indeks',
    CANCEL: 'Batal',
    RECOMMED: 'Rekomendasikan',
    PRICE: 'Harga',
    HIGH: 'Tinggi',
    LOW: 'Rendah',
    RESET: 'Reset',
    SELECT_TIME: 'Pilih Tanggal',
    Hotel_guest: 'Tamu',
    Select: 'Silakan Pilih',
    Emial_address: 'Masukkan alamat email',
    Booking_explan: 'Informasi Pemesanan',
    VIEW_MORE: 'Lihat lebih banyak',
    COLLAPSE: 'Sembunyikan',
    Week: 'Minggu',
    Month: 'Bulan',
    TOURISM_CHECK_IN_HOTEL: 'Check-in',
    TOURISM_LEAVE_HOTEL: 'Check-out',
    arrive: 'Tujuan',
    Room_description: 'Deskripsi Kamar',
    Meals: 'Makanan',
    Room_Type: 'Tipe Kamar',
    BOOKING_EXPLANATION: 'Informasi Pemesanan',
    BOOKING_BUTTON: 'Pesan',
    REMIND_SUBMIT_ORDER: 'Lanjutkan',
    login_now: 'Pemesanan hotel perlu login, login sekarang?',
    the_real_scene: 'Gambar hanya sebagai referensi dan dapat berbeda dengan situasi sebenarnya.',
    Bed: 'Tempat Tidur',
    Rooms: 'Kamar',
    Room_rate: 'Tarif Kamar',
    notified_by_SMS: 'Setelah pemesanan berhasil, Anda akan diinformasikan melalui SMS',
    email_notifications: 'Digunakan untuk menerima pemberitahuan melalui email',
    Booking_deadline: 'Batas Pemesanan',
    Child: 'Anak',
    Additional_notes_about_payment: 'Catatan tambahan tentang pembayaran',
    Nights: 'Malam',
    Minimum_nights_before: 'Minimum',
    Minimum_nights_after: 'malam',
    Size: 'Ukuran',
    Guests: 'Tamu',
    Room_rate_1: 'Tarif Kamar',
    Tax_service_fee: 'Pajak/biaya layanan',
    Pay_now_1: 'Bayar sekarang',
    Filter: 'Filter',
    Room_rate2: 'Tarif Kamar',
    Show_on_map: 'Tampilkan di peta',
    Detail: 'Detail',
    Room_Detail: 'Detail',

    TAXES_INCL: 'Pajak termasuk',
    SEARCH_EMPTY_TIP: 'Maaf, tidak tersedia pada tanggal yang Anda pilih, Anda dapat: mencari tanggal atau hotel alternatif',
    severalNight: 'Malam',
    immediateBooking: 'Pesan Sekarang',
    Refundable: 'Dapat dikembalikan',
    MORE: 'Lebih Banyak',
    adultsCompany: 'dewasa',
    ServiceTerms: 'Layanan & Ketentuan',
    roomPlan: 'Rencana',
    guestRoom: 'Kamar',
    searchAgain: 'Cari lagi',
    roomNight: 'kamar/malam',

    NAME_TXT: 'Nama',
    HOLDER_NAME: 'Nama Pemegang Kartu',
    EXPIRATION_DATE: 'Tanggal Kadaluarsa',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Kode Keamanan',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '3 digit di bagian belakang kartu.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 digit di bagian depan kartu',
    ENTER_COMPLETE_CARD_NUM: 'Harap masukkan nomor kartu lengkap.',
    PLEASE_ENTER_HOLDER_NAME: 'Masukkan nama pemegang kartu',
    ENTER_SECURITY_CODE: 'Masukkan kode keamanan',
    ENTER_EXPIRATION_DATE: 'Masukkan tanggal kadaluarsa',
    ROOM_DETAILS: 'Detail Kamar',
    CONDITION_CANCEL: 'Dapat Dikembalikan',
    CHOOSE_PAYMENT_METHOD: 'Pembayaran',
    ORDER_TOTAL_LUMP: 'Total Pembayaran',
    CREDIT_CARD_NUM: 'Nomor Kartu Debit/Kredit',
    MAINLAND_CARD_ONLY: 'Kartu bank hanya diterbitkan di luar Tiongkok daratan.',
    SHUT_DOWN: 'Tutup',
    PROVIDER_FROM_CHINA_BANK: 'Layanan pembayaran oleh B.O.C',

    COUPON: 'Kupon',
    APPLY_A_COUPON: 'Gunakan Kupon',
    NO_USE: 'Tidak berlaku untuk penawaran ini.',
    Discard: 'Buang',
    REDEEM: 'Tukarkan',
    EMPTY_COUPON: 'Silakan masukkan kode promosi',
    NOTICE_COUPON: 'Hanya satu kupon dapat ditukarkan untuk setiap pemesanan; kupon akan ditukarkan setelah pemesanan diajukan.',

    BREAKFAST_INCLUDE: 'termasuk sarapan',
    BREAKFAST_EXCLUDE: 'tidak termasuk sarapan',
    DOUBLE_BED: 'ranjang ganda',
    TWIN_BED: 'ranjang twin',
    FREE_CANCEL: 'pembatalan gratis',
    MEALS: 'makanan',
    EVALUATION: 'Ulasan',
    FEATURED_REVIEWS: 'Ulasan Unggulan',
    ALL_REVIEWS: 'Semua Ulasan',
    OVERALL_EVALUATION: 'Ulasan Keseluruhan',
    ANONYMOUS: 'Anonim',
    EVAL_GENERAL_LIST_1: 'Buruk',
    EVAL_GENERAL_LIST_2: 'Cukup',
    EVAL_GENERAL_LIST_3: 'Rata-rata',
    EVAL_GENERAL_LIST_4: 'Baik',
    EVAL_GENERAL_LIST_5: 'Sangat Baik',
    MAX_IMAGES_WITH_NINE: 'Maksimal 9 gambar dapat dipilih.',
    GRADE_EVAL: 'Silakan pilih Penilaian Keseluruhan',
    DISTANCE_FILTER: 'jarak dekat-jauh',
    EDIT_EVALUATION: 'berikan komentar',
    GO_TO_EVAL: 'berikan komentar',
    EVAL_POINTS_AWARD: 'Komentar bagus dapat memenangkan 1000 poin, 1000 poin = 10RMB',
    NEARBY_LIKE_HOTEL: 'hotel serupa di sekitar',
    DISTANCE_HOTEL: 'ke hotel',
    PLEASE_ENTER_COMMENT: 'komentar',
    AWARD_POINTS_TIPS: 'Komentar terbaik dapat mendapatkan 1000 poin, 1000 = 10RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Komentar anonim tidak akan menampilkan logo dan nama Anda',
    LOCATION: 'lokasi',
    FACILITY: 'fasilitas',
    SERVICE: 'layanan',
    HEALTH: 'kebersihan',
    LANGUAGE_SELECT: 'bahasa',
    LIMIT_COMMENT_TXT: 'Ulasan harus memiliki 5 hingga 2000 karakter',
    SHARE_MEDIA: 'Bagikan foto dan video',
    SETTLEMENT_FEEL: 'Ulasan',
    SUBMIT_EVAL: 'Konfirmasi',
    HOTEL_STR: 'Detail',
    EVAL_NUM_AFTER: 'ulasan',
  },
  header: {
    SKIING: 'Resor Ski',
    header_internal_call: 'Tiongkok Daratan:',
    header_abroad_call: 'Internasional:',
    header_app_download: 'Aplikasi Seluler',
    service_telephone: 'Layanan Pelanggan',
    account_number: 'Akun',
    if_bg_user: 'Bukan Anggota BaiGolf?',
    home: 'Beranda',
    hotel: 'Hotel',
    Golf: 'Golf',
    PLAY_STAY: 'Stay & Play',
    RENT_CAR_HOME: 'Mobil',
    center_user: 'Pusat Anggota',
    header_my_order: 'Pemesanan Saya',
    header_notmember_order: 'Pemesanan Tamu',
    header_edit_password: 'Ubah Kata Sandi',
    header_logout: 'Keluar',
    header_login: 'Masuk',
    header_register: 'Daftar',
    header_point: 'Poin Saya',
    header_all_language: 'Semua Bahasa',
    down_load_app: 'Pindai Kode QR untuk Mengunduh',
    login_discount_tip: 'Login untuk mendapatkan bonus dan menikmati keuntungan eksklusif Anda',
    currency_balance_limit: 'Mata uang saat ini masih memiliki saldo, tidak dapat mengganti mata uang'
  },
  footer: {
    footer_partner: 'Mitra',
    footer_about_us: 'Tentang Kami',
    footer_about_baigolf: 'Tentang BaiGolf.com',
    footer_privacy_policy: 'Kebijakan Privasi BaiGolf.com',
    footer_use_of_terms: 'Ketentuan Layanan BaiGolf.com',
    footer_contact_us: 'Hubungi Kami',
    footer_sitemap: 'Peta Situs',
    footer_use_of_question: 'FAQ',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'Unduh Aplikasi',
    footer_sina_weibo: 'Sina Weibo',
    footer_tencent_weibo: 'Tencent microblog',
    footer_share_to: 'Bagikan',
    copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Hak Cipta ',
    copyright2: 'Yue ICP Registrasi No.14070002',
    news_center: 'Pusat Berita',
    about_baigolf: 'Tentang BaiGolf',
    help: 'Bantuan',
    management_system: 'Sistem Manajemen Golf BG (BGMS)',
    wechat_official_account: 'Akun Resmi WeChat',
    download_baiGolf_app: 'Unduh Aplikasi BaiGolf',
    privacy_policy: 'Kebijakan Privasi',
    use_of_terms: 'Ketentuan Layanan',
    footer_integral: 'Kebijakan Poin',
    footer_reserve: 'Kebijakan Pemesanan',
    footer_abroad_call: 'Internasional',
    footer_internal_call: 'Tiongkok Daratan'

  }
}



// WEBPACK FOOTER //
// ./src/lang/indo.js